import React, {
  Dispatch,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { InfoType, ItemTypes, PopupsListType } from "../RightSideMenu";
import { earlyWarning } from "../../../mainLayer/earlyWarning/ShowEarlyWarning";
import { hzIncidents } from "../../../mainLayer/hazardIncidentsLayers/IncidentsMenuDropDown";
import { DetailsTypeDataTable } from "../../../mainLayer/summeryComp/detailsSum/DetailTypeDataTable";
import HzTypeDataTable from "../../../mainLayer/summeryComp/detailsSum/HzTypeDataTable";
import Overlay from "ol/Overlay";
import { map } from "../../../mainLayer/MainLayer";
import ReactDOM from "react-dom";
import DetailsByType from "../../../mainLayer/summeryComp/detailsSum/DetailsBytype";

type SideMenuPopupsType = {
  setWindowState: Dispatch<React.SetStateAction<boolean>>;
  earlyWarningsFromChild: earlyWarning[];
  filterHzByType: hzIncidents[];
  typeWindow: Dispatch<React.SetStateAction<boolean>>;
  data: InfoType;
  removeItem: (id: string, type: ItemTypes) => void;
  addItem: (id: string, type: ItemTypes) => void;
  onClose: () => void;
  SumDetailAdd: boolean;
  onCloseDetailPopup: () => void;
};

let EwsAll: earlyWarning[] = [];
let HzAll: hzIncidents[] = [];

const SumDetailByType = (props: SideMenuPopupsType) => {
  const handleClosePopupClick = () => {
    props.setWindowState((prevState) => false);
    props.typeWindow(false);
    EwsAll = [];
    HzAll = [];
    props.onCloseDetailPopup();
  };

  const [isNotRelease, setIsNotRelease] = useState<boolean>(true);
  const popupRef = useRef<HTMLDivElement | null>(null);
  const popupElement = document.createElement("earlyWarningElement");
  const [accumulatedEws, setAccumulatedEws] = useState<earlyWarning[]>([]);
  const fulEW = useRef<earlyWarning[]>([]);
  const [accumulatedHz, setAccumulatedHz] = useState<hzIncidents[]>([]);
  const fulHz = useRef<hzIncidents[]>([]);

  useEffect(() => {
    setAccumulatedEws((prev) => {
      // Combine previous data with new data
      const combinedData = [...prev, ...props.earlyWarningsFromChild];
      // Use a Map to deduplicate by w_id
      const uniqueData = Array.from(
        new Map(combinedData.map((item) => [item.active_pcode, item])).values()
      );
      fulEW.current = uniqueData;
      if (!props.SumDetailAdd) {
        EwsAll = fulEW.current;
      }

      return uniqueData;
    });
  }, [props.earlyWarningsFromChild]);

  useEffect(() => {
    setAccumulatedHz((prev) => {
      // Combine previous data with new data
      const combinedData = [...prev, ...props.filterHzByType];
      // Use a Map to deduplicate by w_id
      const uniqueData = Array.from(
        new Map(combinedData.map((item) => [item.w_id, item])).values()
      );
      fulHz.current = uniqueData;
      if (!props.SumDetailAdd) {
        HzAll = fulHz.current;
      }
      return uniqueData;
    });
  }, [props.filterHzByType]);

  const mouseMoveEvent = useCallback(
    (event: MouseEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );

        if (
          sideMenuWidth > event.clientX &&
          accumulatedEws.length === fulEW.current.length &&
          accumulatedHz.length === fulHz.current.length
        ) {
          ReactDOM.render(
            <DetailsByType
              onClose={props.onClose}
              earlyWarningsFromChild={EwsAll}
              filterHzByType={props.SumDetailAdd ? HzAll : props.filterHzByType}
              addItem={props.addItem}
              id={props.data.id}
            />,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });

          overlay.setPosition([7.873054, 90.771797]);
          map.addOverlay(overlay);
          props.removeItem(props.data.id, "sumDetail");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease, accumulatedEws, accumulatedHz]
  );

  const mouseMoveEventTouch = useCallback(
    (event: TouchEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );
        const touchX = event.touches[0].clientX;
        if (
          sideMenuWidth > touchX &&
          accumulatedEws.length === fulEW.current.length &&
          accumulatedHz.length === fulHz.current.length
        ) {
          ReactDOM.render(
            <DetailsByType
              onClose={props.onClose}
              earlyWarningsFromChild={EwsAll}
              filterHzByType={props.SumDetailAdd ? HzAll : props.filterHzByType}
              addItem={props.addItem}
              id={props.data.id}
            />,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });

          overlay.setPosition([7.873054, 80.771797]);
          map.addOverlay(overlay);
          props.removeItem(props.data.id, "sumDetail");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease, accumulatedEws, accumulatedHz]
  );

 useEffect(() => {
      const handleMouseDown = () => {
        document.addEventListener("mousemove", mouseMoveEvent);
        document.addEventListener("mouseup", handleMouseUp);
      };
    
      const handleMouseUp = () => {
        document.removeEventListener("mousemove", mouseMoveEvent);
        document.removeEventListener("mouseup", handleMouseUp);
      };
    
      const handleTouchStart = () => {
        document.addEventListener("touchmove", mouseMoveEventTouch);
        document.addEventListener("touchend", handleTouchEnd);
      };
    
      const handleTouchEnd = () => {
        document.removeEventListener("touchmove", mouseMoveEventTouch);
        document.removeEventListener("touchend", handleTouchEnd);
      };
    
      if (popupRef.current) {
        popupRef.current.addEventListener("mouseenter", () => {
          popupRef.current?.addEventListener("mousedown", handleMouseDown);
          popupRef.current?.addEventListener("touchstart", handleTouchStart);
        });
      }
    
      return () => {
        document.removeEventListener("mousemove", mouseMoveEvent);
        document.removeEventListener("mouseup", handleMouseUp);
        document.removeEventListener("touchmove", mouseMoveEventTouch);
        document.removeEventListener("touchend", handleTouchEnd);
      };
    }, [mouseMoveEvent, mouseMoveEventTouch]);

  return (
    <div className={`popup data-table`} ref={popupRef}>
      <div className={`titleWrapper`}>
        <span>Details by Type</span>
        <div className={`titleButtonContainer no-drag`}>
          <i className={`titleIcon fullScreenIco`}></i>
          <i
            className={`titleIcon closeIco`}
            onClick={(e) => handleClosePopupClick()}
            onTouchStart={(e) => handleClosePopupClick()}
          ></i>
        </div>
      </div>
      {props.earlyWarningsFromChild.length !== 0 && (
        <div className={`data-table-wrapper no-drag`}>
          <DetailsTypeDataTable
            earlyWarningsFromChild={
              props.SumDetailAdd ? EwsAll : props.earlyWarningsFromChild
            }
          />
        </div>
      )}
      {props.filterHzByType.length !== 0 && (
        <div className={`data-table-wrapper no-drag`}>
          <HzTypeDataTable
            hzDatafromSummery={
              props.SumDetailAdd ? HzAll : props.filterHzByType
            }
          />
        </div>
      )}
    </div>
  );
};

export default SumDetailByType;
